import { api } from "../../lib";

export interface SpecimenMacro {
  id: string;
  code: string;
  description: string | null;
  sourceId: string | null;
  subsiteId: string | null;
  findings: string | null;
  collectionMethod: string | null;
  material: string | null;
  isActive: boolean;
  source: { id: string; name: string } | null;
  subsite: { id: string; name: string } | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSpecimenMacroInput {
  code: string;
  description?: string;
  sourceId?: string | null;
  subsiteId?: string | null;
  findings?: string;
  collectionMethod?: string;
  material?: string | null;
  isActive?: boolean;
}

export interface UpdateSpecimenMacroInput {
  id: string;
  code?: string;
  description?: string;
  sourceId?: string | null;
  subsiteId?: string | null;
  findings?: string;
  collectionMethod?: string;
  material?: string | null;
  isActive?: boolean;
}

export interface SpecimenBatchTemplate {
  id: string;
  name: string;
  specimenCount: number;
  defaultMaterial: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSpecimenBatchTemplateInput {
  name: string;
  specimenCount: number;
  defaultMaterial?: string | null;
  isActive?: boolean;
}

export interface UpdateSpecimenBatchTemplateInput {
  id: string;
  name?: string;
  specimenCount?: number;
  defaultMaterial?: string | null;
  isActive?: boolean;
}

export const specimenMacroService = {
  getAll: async () => {
    return api.get<SpecimenMacro[]>("/admin/specimen-macros");
  },

  create: async (input: CreateSpecimenMacroInput) => {
    return api.post<SpecimenMacro>("/admin/specimen-macros", input);
  },

  update: async (input: UpdateSpecimenMacroInput) => {
    const { id, ...updates } = input;
    return api.put<SpecimenMacro>(`/admin/specimen-macros/${id}`, updates);
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/specimen-macros/${id}`);
  },

  toggleActive: async (id: string) => {
    return api.patch<SpecimenMacro>(
      `/admin/specimen-macros/${id}/toggle-active`
    );
  },
};

export const specimenBatchTemplateService = {
  getAll: async () => {
    return api.get<SpecimenBatchTemplate[]>("/admin/specimen-batch-templates");
  },

  create: async (input: CreateSpecimenBatchTemplateInput) => {
    return api.post<SpecimenBatchTemplate>(
      "/admin/specimen-batch-templates",
      input
    );
  },

  update: async (input: UpdateSpecimenBatchTemplateInput) => {
    const { id, ...updates } = input;
    return api.put<SpecimenBatchTemplate>(
      `/admin/specimen-batch-templates/${id}`,
      updates
    );
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/specimen-batch-templates/${id}`);
  },

  toggleActive: async (id: string) => {
    return api.patch<SpecimenBatchTemplate>(
      `/admin/specimen-batch-templates/${id}/toggle-active`
    );
  },
};
